import React from "react";
import PropTypes from "prop-types";
import pillsPropType from "../../ChildLinks/propTypes/pills";
import styles from "./index.css";
import ChildLinks from "../../ChildLinks";
import Pill from "../../ChildLinks/Pill";
import { LARGE_VIEWPORT } from "../../../state/modules/layout/constants";

const Pills = ({ pills, viewport }) => {
  if (!pills.length) return null;

  if (viewport === LARGE_VIEWPORT) {
    return (
      <div className={styles.container}>
        <ChildLinks />
      </div>
    );
  } else {
    return (
      <ul className={styles.container} data-auto-id="childLinksContainer">
        {pills.map(p => (
          <Pill {...p} key={p.friendlyName} extraClassName={styles.pill} />
        ))}
      </ul>
    );
  }
};

Pills.propTypes = {
  pills: pillsPropType.isRequired,
  viewport: PropTypes.string.isRequired
};

export default Pills;
